import {
  ClipboardList, Users, Contact, Receipt,
  Package, Tags, Percent, Truck, Star, Trophy, Gift,
  Calendar, Sparkles, Cpu, Radio, Flag, Images, MapPin,
  TrendingUp, Megaphone, Mail, FileText, Bell, Newspaper, Image as ImageIcon, MailCheck,
  Palette, ShieldCheck, Store, Link2, Database, BarChart3, CreditCard,
  LayoutDashboard, Building2, Tablet, Wrench, Clock, MailOpen, ShieldAlert,
  BookOpen, Boxes, LifeBuoy,
} from 'lucide-react';

// Single source of truth for the admin navigation. Used by the persistent
// sidebar and the dashboard quick-access grid.
//
// Six operational tiers, ordered by how often they are used: the daily venue
// floor work sits at the top, sensitive accounting and system settings at the
// bottom. Every `to` is an existing route — the tiering is presentation only.
export const ADMIN_NAV = [
  {
    group: 'Operations & Sim Fleet',
    items: [
      { to: '/admin/bookings', icon: Calendar, label: 'Bookings' },
      { to: '/admin/group-bookings', icon: Users, label: 'Group Bookings' },
      { to: '/admin/experiences', icon: Sparkles, label: 'Experiences' },
      { to: '/venue/pos', icon: Tablet, label: 'Venue POS & Dispatch' },
      { to: '/admin/rigs', icon: Cpu, label: 'Sim Rigs' },
      { to: '/admin/showcase-rigs', icon: Images, label: 'Simulator Showcase' },
      { to: '/admin/live-telemetry', icon: Radio, label: 'Live Telemetry' },
      { to: '/admin/session-results', icon: Flag, label: 'Session Results' },
      { to: '/admin/venue', icon: MapPin, label: 'Venue Management' },
      { to: '/admin/opening-hours', icon: Clock, label: 'Opening Hours' },
    ],
  },
  {
    group: 'Orders & E-Commerce',
    items: [
      { to: '/admin/orders', icon: ClipboardList, label: 'Sales' },
      { to: '/admin/products', icon: Package, label: 'Products' },
      { to: '/admin/stock-control', icon: Boxes, label: 'Stock Control' },
      { to: '/admin/categories', icon: Tags, label: 'Categories' },
      { to: '/admin/discount-codes', icon: Percent, label: 'Discount Codes' },
      { to: '/admin/gift-cards', icon: Gift, label: 'Gift Cards' },
      { to: '/admin/ebay', icon: Store, label: 'eBay Store Sync' },
      { to: '/admin/shipping', icon: Truck, label: 'Postal Settings' },
    ],
  },
  {
    group: 'Customer CRM & Cases',
    items: [
      // Customer CRM carries the cases queue and the customer directory as
      // tabs, so it also owns those two routes for highlighting and badges.
      { to: '/admin/crm', icon: Contact, label: 'Customer CRM', badge: 'cases', match: ['/admin/crm/directory'] },
      { to: '/admin/b2b', icon: Building2, label: 'Trade & Consumer Accounts' },
      { to: '/admin/customer-service', icon: LifeBuoy, label: 'Support & RMAs', badge: 'rma', match: ['/admin/returns'] },
      { to: '/admin/email-inbox', icon: MailOpen, label: 'Unified Inbox', badge: 'email', match: ['/admin/sms-inbox'] },
      { to: '/admin/reviews', icon: Star, label: 'Reviews & Feedback', badge: 'reviews', match: ['/admin/feedback'] },
    ],
  },
  {
    group: 'Marketing & CMS',
    items: [
      { to: '/admin/marketing', icon: TrendingUp, label: 'Marketing & SEO' },
      { to: '/admin/social-posts', icon: Megaphone, label: 'Social Posts' },
      { to: '/admin/newsletter', icon: Mail, label: 'Newsletter' },
      { to: '/admin/email-templates', icon: FileText, label: 'Email Templates' },
      { to: '/admin/email-testing', icon: MailCheck, label: 'Email Test Center' },
      { to: '/admin/competition', icon: Trophy, label: 'Sim Competition' },
      { to: '/admin/blog', icon: Newspaper, label: 'Blog Posts' },
      { to: '/admin/corporate-brochure', icon: BookOpen, label: 'Corporate Brochure' },
      { to: '/admin/page-media', icon: ImageIcon, label: 'Page Media' },
      { to: '/admin/brand-assets', icon: ImageIcon, label: 'Brand Assets' },
    ],
  },
  {
    group: 'Finance & Accounting',
    items: [
      { to: '/admin/invoices', icon: Receipt, label: 'Invoices / Credits' },
      { to: '/admin/invoice-design', icon: Palette, label: 'Invoice Design' },
      { to: '/admin/analytics', icon: BarChart3, label: 'Analytics & Exports' },
      { to: '/admin/compensation', icon: ShieldAlert, label: 'Compensation & Refund Log' },
    ],
  },
  {
    group: 'System & Settings',
    items: [
      { to: '/admin/users', icon: ShieldCheck, label: 'Admin Users' },
      { to: '/admin/order-notifications', icon: Bell, label: 'Notification Recipients' },
      { to: '/admin/apple-pay', icon: CreditCard, label: 'Apple Pay Domains' },
      { to: '/admin/local-sync', icon: Database, label: 'Local DB Sync' },
      { to: '/admin/redirects', icon: Link2, label: 'URL Redirects' },
      { to: '/admin/maintenance', icon: Wrench, label: 'System Maintenance History' },
    ],
  },
];

export const DASHBOARD_LINK = { to: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' };